'use client';

import { PageTitleButtonBlock } from './pageTitleButtonBlock';
import { RoutingFeatureCard } from './routingFeatureCard';
import { getRoutingFeatureCards, type RoutingFeatureMedia } from '../constants';

import { useCurrentLocale, useGetClientHost } from '@/shared/hooks';
import { TranslatedComponent } from '@/shared/types';
import { getDomainKey } from '@/shared/utils/getDomainInfo';

interface Props extends TranslatedComponent {
  media: RoutingFeatureMedia;
}

export const RoutingFeaturesGrid = ({ translations, media }: Props) => {
  const domain = getDomainKey(useGetClientHost());
  const locale = useCurrentLocale();

  const cards = Object.values(getRoutingFeatureCards(translations, locale));

  return (
    <div className="mt-20 max-sm:mt-9">
      {/** Мобильная версия */}
      <div className="flex flex-col gap-4 md:hidden">
        {cards.map((card) => (
          <RoutingFeatureCard
            key={card.id}
            card={card}
            media={
              card.imageUrl === 'dynamic' ? media[card.id][domain] : undefined
            }
            forceMobileLayout
          />
        ))}
      </div>

      {/** Desktop версия */}
      <div className="grid grid-cols-2 grid-rows-[386px_644px_386px] gap-8 max-sm:hidden">
        {cards.map((card) => (
          <RoutingFeatureCard
            key={card.id}
            card={card}
            media={
              card.imageUrl === 'dynamic' ? media[card.id][domain] : undefined
            }
          />
        ))}
      </div>

      {/** Блок с кнопками */}
      <div className="mt-8 flex justify-center max-sm:mt-7">
        <div className="inline-flex">
          <PageTitleButtonBlock translations={translations} />
        </div>
      </div>
    </div>
  );
};
